$(document).ready(function () {
  if(null){
    CartJS.init(null);
  }
});
addDataToCart()
// console.log(window['metafield_json'])

$(document).on('click', 'button[type="submit"], .product-action .add-to-cart', function (e) {
  e.preventDefault();
  var id = $('select[name="id"]').val() || $('[name="id"]').val()
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: parseInt($('input[name="quantity"]').val()) || 1,
      id: id
    },
    dataType: 'json', 
    success: function (data) {
      //            $('span.cart-item-count.js-cart-item-count').text(data.quantity);
      addDataToCart()
      if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
        BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
        BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
      }

     // on()
      
      $('.cart-wrapper').addClass('active');
      document.querySelector('.js-open-cart').click()
    },
    error: function(e){
      console.log(e.responseJSON.description)
    }
  });
})


function addItemToCart(variant_id, qty, selling_plan) {

  data = {
    "id": variant_id,
    "quantity": qty,
    "selling_plan": selling_plan
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      addDataToCart();
      document.querySelector('.js-open-cart').click()
    },
    error: function(e){
      console.log(e.responseJSON.description)
    }
  });
}





//Cart Js cart request Started
$(document).on('cart.requestStarted', function(event, cart) {
  // Event handling here.
  $('a.addtocart-txt,.w-button,.js-remove-line,[type="submit"],.cart-number').css({
    'pointer-events': 'none',
    'opacity': '0.2'
  })
});

$(document).on('cart.requestComplete', function (event, cart) {
  setTimeout(() => {
             $('a.addtocart-txt,.w-button,.js-remove-line,[type="submit"],.cart-number').css({
    'pointer-events': 'auto',
    'opacity': '1'
  })

}, 300)
$('.js-open-cart .final-price, span.nav-cart__count').text(cart.item_count);
addDataToCart()
});

function updateQuantity(type, id) {
  $('a.addtocart-txt,.w-button,.js-remove-line,[type="submit"],.cart-number').css({
    'pointer-events': 'none',
    'opacity': '0.4'
  })
  var originalVal = parseInt($('#quan_' + id).html());
  if (type == 'add') {
    $('#quan_' + id).html(originalVal + 1)
  } else {
    if (originalVal > 0) {
      $('#quan_' + id).html(originalVal - 1)
    }
  }
  updItem(id, parseInt($('#quan_' + id).html()))
}
function changeQty(type, id){
  var valu = parseInt($("button#add-to-cart-button #num-qty").html())
  if(type=='add'){
    $("button#add-to-cart-button #num-qty").html(valu+1)
  }else{
    if(valu > 1){
      $("button#add-to-cart-button #num-qty").html(valu-1)
    }
  }
}

function updItem(selected_variant_id, qty) {
  var update_data = {
    "quantity": qty,
    "id": selected_variant_id
  };

  if (update_data) {
    $.ajax({
      type: 'POST',
      async: true,
      url: '/cart/change.js',
      data: update_data,
      dataType: 'json',
      success: function (d) {
        setTimeout(() => {
                   $('a.addtocart-txt,.w-button,.js-remove-line,[type="submit"],.cart-number').css({
          'pointer-events': 'auto',
          'opacity': '1'
        })
      }, 300)
      addDataToCart()
    },
           failure: function (d) {
    }
  });
}
}

$('a.cart-item-remove.js-remove-line').click(e => {
  e.preventDefault();
  var lineItem = e.target.href.split('line=')[1].split('&')[0]
  CartJS.removeItem(lineItem);

})
function on() {
  document.getElementById("overlay").style.display = "block";
  document.body.style.overflowY = 'hidden';
}
function off() {
  document.getElementById("overlay").style.display = "none";
  document.body.style.overflowY = 'auto';
}
var hide;
var hideId;
function addDataToCart() {
  $.ajax({
    url: "/cart.js",
    type: 'GET',
    dataType: 'json', // added data type
    success: function (res) {
      if(res.items.length > 0){
      $.getJSON('/products/' + res.items[0].handle + '.js', function (product) {
        $('.cart-footer.cart-masked-overflow .recommended-items-header, .cart-footer.cart-masked-overflow .recommended-product').hide()
        // $('.mobile-recommended .recommended-items-header, .mobile-recommended .recommended-product').hide()

            product.tags.slice().reverse().forEach(x=>{
              if(x.includes('recommended')){
                console.log(x);
                var handle = x.split(':')[1].trim();
                $.getJSON('/products/' + handle + '.js', function (product) {
                $('.recommended-product').html(`
                <div class="container">
                <img src="${product.featured_image}">
                <div class="recommended-product__meta">
                <h6 class="title">${product.title}</h6>
                <div class="recommended-product__price">${(product.variants[0].price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</div>
                
                <button onclick="CartJS.addItem(${product.variants[0].id});" type="button" class="recommended-product__meta__button">
                Tāpiria ki tō kāta
                </button>
                </div>
                
                </div>
                `)
                })
                // $('.cart-footer.cart-masked-overflow .recommended-items-header, .cart-footer.cart-masked-overflow .recommended-product').show()
                
                $('.mobile-recommended .recommended-items-header, .mobile-recommended .recommended-product').show()
                $('.desktop-recommended .recommended-items-header, .desktop-recommended .recommended-product').show()

                return;
              }
            })
      })
      }else{
        // $('.cart-footer.cart-masked-overflow .recommended-items-header, .cart-footer.cart-masked-overflow .recommended-product').hide()
        $('.mobile-recommended .recommended-items-header, .mobile-recommended .recommended-product').hide()
        $('.desktop-recommended .recommended-items-header, .desktop-recommended .recommended-product').hide()
      }
      var html = '';
      hide = [];
      hideId = [];
      var money = '';
      var items = res.items
      //       console.log(items)
      for (var i = 0; i < items.length; i++) {

        if($('[data-manual="'+items[i].product_id+'"]').length){
          hide.push($('[data-manual="'+items[i].product_id +'"]'));
          hideId.push(items[i].product_id);
        }
// console.log(window['metafield_json'][items[i].product_id])
        items[i].selling_plan_allocation ? money = `
<strike>${(items[i].selling_plan_allocation.compare_at_price/100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</strike>
<span class="money" style="display: inline-block !important;margin-left: 5px">$${(items[i].final_price / 100).toFixed(2)}</span>
<small style="display:block">I whakahikotia ia ${items[i].selling_plan_allocation.selling_plan.options[0].value} <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" style="margin-left:10px;position:relative;top:3px">
<g fill="#686158" fill-rule="evenodd" stroke="#686158" stroke-width=".5" style="fill:var(--blue);stroke:var(--blue)">
<path d="M14.608 6.082a.315.315 0 0 1-.304-.223c-.888-3.081-4.206-4.887-7.41-4.033-2.038.543-3.63 2.074-4.195 4.033a.32.32 0 0 1-.396.2.303.303 0 0 1-.214-.363c.977-3.405 4.64-5.404 8.183-4.464 2.256.6 4.02 2.294 4.643 4.464a.304.304 0 0 1-.221.375.336.336 0 0 1-.086.011M8.5 13.799c-2.992.003-5.617-1.917-6.413-4.69a.304.304 0 0 1 .232-.369.319.319 0 0 1 .378.206c.888 3.081 4.206 4.887 7.41 4.033 2.038-.543 3.63-2.074 4.195-4.033a.32.32 0 0 1 .396-.2c.16.047.255.206.215.363-.796 2.772-3.42 4.692-6.412 4.69" style=""></path>
<path d="M14.608 6.082a.327.327 0 0 1-.135-.028l-2.29-1.036a.3.3 0 0 1-.132-.412c.076-.14.251-.2.402-.139l2.003.904.943-1.925a.323.323 0 0 1 .428-.128.3.3 0 0 1 .144.388l-1.077 2.201a.318.318 0 0 1-.286.175M1.318 11.534A.31.31 0 0 1 1 11.23c0-.045.01-.09.03-.13l1.078-2.203a.322.322 0 0 1 .42-.146h.002l2.29 1.036a.3.3 0 0 1 .133.412.323.323 0 0 1-.403.139l-2.005-.904-.942 1.926a.318.318 0 0 1-.285.174"></path>
</g>
</svg></small>
' : moni = '<span class="money">$${(items[i].final_price / 100).toFixed(2)}</span>`;

html = html + 
          `<div class="cart-item" data-id="${items[i].product_id}" data-handle="${ items[i].handle }">
<div class="thumb">
<img src="${window['metafield_json'][items[i].product_id] ?  window['metafield_json'][items[i].product_id] : items[i].image}" alt="Ingoa Hua">
</div>
<div class="meta">
<div class="title">${items[i].title}</div>
<div class="pricing">
<span class="price">
${money}</span>
</div>
<div class="cart-product-qnty">
<div class="cart-remove-add">
<a href="#" class="cart-minus w-button" onclick="updateQuantity('sub', ${items[i].id})">–</a> 
<div class="cart-number shipgray-color" id="quan_${items[i].id}">${items[i].quantity}</div> 
<a href="#" class="cart-add w-button" data-id="${items[i].id}" onclick="updateQuantity('add', ${items[i].id})">+</a> 
</div>
</div>
<a href="#" data-id="${items[i].id}" onclick="CartJS.removeItemById(${items[i].id});" class="remove">Tango</a>
</div>
</div>`;

}
      $('.your-cart .cart-products').html(html)
      $('.checkout span').html('<span class="money">$' + (res.total_price / 100).toFixed(2)+'</span>')

      $('.js-open-cart .final-price, span.nav-cart__count').html(res.item_count);
      $('span.cart-count, span.mobile-cart-count, .cart-count-bubble span[aria-hidden="true"]').html(res.item_count)


      if( $(`.your-cart .cart-products [data-handle="${ donation_handle }"]`).length ) {
        // Already Donated
      
      } else {
        // Haven't Donated

      }

      $('body').toggleClass('cart--donated', $(`.your-cart .cart-products [data-handle="${ donation_handle }"]`).length > 0);
      $('body').toggleClass('cart--empty', res.item_count == 0);
      $('body').toggleClass('cart--not-empty', res.item_count > 0);



      if(res.item_count > 0){
        $('button.checkout').show()
        $('.no-products').hide()
        // $('.shipping-text').show()
        $('.cart-bird').show()
        $('.continue-shopping__wrapper').show()
        $('.cart-note__link').show()
        $('.continue-shopping--link--shipping-desktop').show()

        
        if( window.innerWidth >= 480 ) {
          // $('.cart-note__input--wrapper').show()
        }

        $('.cart-note__link').show()

        

      }else{
        $('button.checkout').hide()
        $('.no-products').show()
        // $('.shipping-text').hide()
        $('.cart-bird').hide()
		    $('.cart-note__link').hide()
        $('.continue-shopping__wrapper').show()
        

        $('.cart-note__input--wrapper').hide()
        $('.cart-note__link').hide()

        $('.continue-shopping--link--shipping-desktop').hide()

      }
    }
  });

}


$('.checkout').click(()=>{
                     window.location.href = '/checkout'                     
                     })


function removeElement(id) {
  var elem = document.getElementById(id);
  return elem.parentNode.removeChild(elem);
}
